export default {
    AUCTION_LIMIT_EDIT: 'AUCTION_LIMIT_EDIT',
    AUCTION_LIMIT_VIEW: 'AUCTION_LIMIT_VIEW',
    AUCTION_TEMPLATE_EDIT: 'AUCTION_TEMPLATE_EDIT',
    AUCTION_TEMPLATE_VIEW: 'AUCTION_TEMPLATE_VIEW',
    EMAIL_TEMPLATE_EDIT: 'EMAIL_TEMPLATE_EDIT',
    EMAIL_TEMPLATE_VIEW: 'EMAIL_TEMPLATE_VIEW',
    AUCTIONEER_DATA_TEMPLATE_EDIT: 'AUCTIONEER_DATA_TEMPLATE_EDIT',
    CASH_LIMIT_EDIT: 'CASH_LIMIT_EDIT',
    CASH_LIMIT_VIEW: 'CASH_LIMIT_VIEW',
    MANUAL_CASH_LIMIT_EDIT: 'MANUAL_CASH_LIMIT_EDIT',
    MANUAL_CASH_LIMIT_VIEW: 'MANUAL_CASH_LIMIT_VIEW',
    CLEARING_HOUSE_EDIT: 'CLEARING_HOUSE_EDIT',
    CLEARING_HOUSE_VIEW: 'CLEARING_HOUSE_VIEW',
    CURRENCY_EDIT: 'CURRENCY_EDIT',
    SUBMARKET_EDIT: 'SUBMARKET_EDIT',
    PRODUCT_VIEW: 'PRODUCT_VIEW',
    PRODUCT_EDIT: 'PRODUCT_EDIT',
    AUCTION_VIEW_ALL: 'AUCTION_VIEW_ALL',
    AUCTION_VIEW_OWN: 'AUCTION_VIEW_OWN',
    AUCTION_EDIT: 'AUCTION_EDIT',
    AUCTION_DETAIL_VIEW_ALL: 'AUCTION_DETAIL_VIEW_ALL',
    SETTINGS_EDIT: 'SETTINGS_EDIT',
    BID_EDIT_OWN: 'BID_EDIT_OWN',
    BID_EDIT_ALL: 'BID_EDIT_ALL',
    BID_VIEW_OWN: 'BID_VIEW_OWN',
    BID_VIEW_ALL: 'BID_VIEW_ALL',
    BID_EDIT_AS_BROKER: 'BID_EDIT_AS_BROKER',
    MESSAGE_VIEW: 'MESSAGE_VIEW',
    MESSAGE_EDIT: 'MESSAGE_EDIT',
    USER_EDIT: 'USER_EDIT',
    USER_VIEW: 'USER_VIEW',
    MEMBER_VIEW: 'MEMBER_VIEW',
    MEMBER_EDIT: 'MEMBER_EDIT',
    REPORT_VIEW: 'REPORT_VIEW',
    ZONE_EDIT_ALL: 'ZONE_EDIT_ALL',
    ZONE_VIEW_ALL: 'ZONE_VIEW_ALL',
    ZONE_VIEW_OWN: 'ZONE_VIEW_OWN',
    ZONE_VIEW_LABEL: 'ZONE_VIEW_LABEL',
    HOLIDAY_EDIT: 'HOLIDAY_EDIT',
};
